// Build-time landing configuration. Nothing here has a default that points at an unconfirmed mailbox or origin.

const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;

// REACT_APP_DEMO_CONTACT_EMAIL: the owner-confirmed address for visitors when the form cannot be used.
export const getContactEmail = (raw = process.env.REACT_APP_DEMO_CONTACT_EMAIL) => {
  const value = (raw || '').trim();
  return EMAIL_PATTERN.test(value) && value.length <= 254 ? value : null;
};

// The address always comes from getContactEmail(); there is no default. A body template is optional.
export const contactMailto = (email, { subject = 'Kennismaking Zoea', body = '' } = {}) =>
  `mailto:${email}?subject=${encodeURIComponent(subject)}${body ? `&body=${encodeURIComponent(body)}` : ''}`;

// https only; the server already restricts the host, this guards what the browser will ever link to.
export const safePrivacyUrl = (value) => {
  if (typeof value !== 'string' || value.length > 500) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    return url.href;
  } catch {
    return null;
  }
};

// REACT_APP_CANONICAL_ORIGIN, else the production host when (and only when) served from it; otherwise null so
// previews, localhost and other hosts never announce a canonical or Open Graph URL for the production site.
const PRODUCTION_HOSTS = ['zoea.nl', 'www.zoea.nl'];

export const getCanonicalOrigin = (
  configured = process.env.REACT_APP_CANONICAL_ORIGIN,
  location = window.location,
) => {
  const value = (configured || '').trim().replace(/\/+$/, '');
  if (value) {
    try {
      const url = new URL(value);
      if (url.protocol === 'https:' && !url.username && !url.password && url.origin === value) return url.origin;
    } catch {
      return null;
    }
    return null;
  }
  return PRODUCTION_HOSTS.includes(location.hostname) && location.protocol === 'https:' ? 'https://zoea.nl' : null;
};
